import { Box } from "@mui/material";
import { LineItemDto, RateToggle, SiteHaulingLineItemDto } from "../dtos";
import { formatCurrency } from "./formatCurrency";

export function getHaulingRateFromLineItem(row: LineItemDto | SiteHaulingLineItemDto) {

    switch (row.rateToggle) {
        case RateToggle.Standard:
            return row.haulingRate ? <Box>ST: {formatCurrency(row.haulingRate)}</Box> : '';
        case RateToggle.Flat:
            return row.haulingFlatRate ? <Box>FL: {formatCurrency(row.haulingFlatRate)}</Box> : '';
        case RateToggle.Both:
            const hasAssociatedLineItem = row.associatedLineItemId !== null;
            const isFlatRateApplied = row.associatedLineItemId !== null && row.flatRateApplied; 
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'normal' : 'bold' : 'normal' }}>ST: {row.haulingRate ? formatCurrency(row.haulingRate) : ''}</Box>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'bold' : 'normal' : 'normal' }}>FL: {row.haulingFlatRate ? formatCurrency(row.haulingFlatRate) : ''}</Box>
                </Box>
            );
        default:
            return '';
    }
}

export function getDriverRateFromLineItem(row: LineItemDto | SiteHaulingLineItemDto) {
    
    switch (row.rateToggle) {
        case RateToggle.Standard:
            return row.driverRate ? <Box>ST: {formatCurrency(row.driverRate)}</Box> : '';
        case RateToggle.Flat:
            return row.driverFlatRate ? <Box>FL: {formatCurrency(row.driverFlatRate)}</Box> : '';
        case RateToggle.Both:
            const hasAssociatedLineItem = row.associatedLineItemId !== null;
            const isFlatRateApplied = row.associatedLineItemId !== null && row.driverFlatRateApplied;
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'normal' : 'bold' : 'normal' }}>ST: {row.driverRate ? formatCurrency(row.driverRate) : ''}</Box>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'bold' : 'normal' : 'normal' }}>FL: {row.driverFlatRate ? formatCurrency(row.driverFlatRate) : ''}</Box>
                </Box>
            );
        default:
            return '';
    }
};

export function getBrokerRateFromLineItem(row: LineItemDto | SiteHaulingLineItemDto) {

    switch (row.rateToggle) {
        case RateToggle.Standard:
            return row.brokerRate ? <Box>ST: {formatCurrency(row.brokerRate)}</Box> : '';
        case RateToggle.Flat:
            return row.brokerFlatRate ? <Box>FL: {formatCurrency(row.brokerFlatRate)}</Box> : '';
        case RateToggle.Both:
            const hasAssociatedLineItem = row.associatedLineItemId !== null;
            const isFlatRateApplied = row.associatedLineItemId !== null && row.brokerFlatRateApplied;
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'normal' : 'bold' : 'normal' }}>ST: {row.brokerRate ? formatCurrency(row.brokerRate) : ''}</Box>
                    <Box sx={{ fontWeight: hasAssociatedLineItem ? isFlatRateApplied ? 'bold' : 'normal' : 'normal' }}>FL: {row.brokerFlatRate ? formatCurrency(row.brokerFlatRate) : ''}</Box>
                </Box>
            );
        default:
            return '';
    }
};